var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('v-modal-target',{staticClass:"modal-target",attrs:{"name":"modal-target"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }